import React from 'react'
import icon from './svgs/close.svg'
import { BaseIcon } from './_base'

export const CloseIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
